import Vue from "vue";
import App from "./App.vue";
import router from "./router.js";
// 引入全局css样式控制文件
import "./assets/css/global.css";
// 引入elementui组件库
import "element-ui/lib/theme-chalk/index.css";
import ElementUI from "element-ui";
Vue.use(ElementUI);
import VDistpicker from "v-distpicker";
Vue.component("v-distpicker", VDistpicker);

//注册过滤器
import moment from "moment";
Vue.filter("ft", () => {
  return moment().format("YYYY-MM-DD HH:mm:ss");
});
//引用百度地图
import BaiduMap from "vue-baidu-map";
Vue.use(BaiduMap, {
  ak: "GGgeneOhjoNUxBGHUvDWgYtvfDafvbTS"
});

// 引入axios并配置
import axios from "./http";
Vue.prototype.$http = axios;

// eslint-disable-next-line no-unused-vars
router.afterEach((to, from, next) => {
  setTimeout(() => {
    // 此处粘贴百度统计复制过来的代码
    var _hmt = _hmt || [];
    (function() {
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?769aa16b2190c1081957ae87ad6cf2a6";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();
  }, 0);
});
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
